module.exports = __webpack_public_path__ + "img/guest-active.2e26156c.png";